// angular
import { TranslateModule } from '@ngx-translate/core';
import { Component, input, OnChanges } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
// components
import { VideoPlayerComponent } from '@app/core/components/video-player/video-player.component';
import { GalleryComponent } from '@app/core/components/gallery/gallery.component';
// interfaces & types & env
import { IMedia } from '@app/shared/interfaces/media.interface';
import { ExpertOpinionsType } from '@app/+products/shared/types/expert-opinions.type';
import { environment } from '@environments/environment';
// pipes
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';

@Component({
  selector: 'pwj-product-expert-opinions',
  standalone: true,
  imports: [
    NgOptimizedImage,
    VideoPlayerComponent,
    TranslateModule,
    TranslateDataPipe,
    ImageSourcePipe,
    GalleryComponent,
  ],
  templateUrl: './product-expert-opinions.component.html',
  styleUrl: './product-expert-opinions.component.scss',
})
export class ProductExpertOpinionsComponent implements OnChanges {
  public selectedMedia!: IMedia;
  public baseUrl: string = environment.baseUrl.base;

  // inputs
  expertOpinionsData = input.required<ExpertOpinionsType>();

  constructor() {}

  ngOnChanges(): void {
    if (this.expertOpinionsData) {
      this.selectedMedia = this.expertOpinionsData()?.specialist_photos?.[0];
    }
  }

  public onSelectMedia(image: IMedia) {
    this.selectedMedia = image;
  }
}
